module.exports = "<div class=nn-addon-soundcloud><iframe ng-src=\"{{ soundcloudSettings.source }}\"></iframe></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-add-ons/nn-addon-soundcloud/nn-addon-soundcloud.directive.html
// module id = 946
// module chunks = 0